import React from 'react';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import VehicleBasicInfoComponent from './vehicle-basic-info.component';
import { UploadMedia } from '../../../../../../common/components/common/upload-media';

export const VehicleComponent = ({ vehicleBodyTypes, vehicleCategories, parmas, onFormItemChange, handleInnerFormChange, selectedVehicle, transportAgents, transporters, back, handleFormSubmit }: any) => {


  const handleInnerMediaFormChange: any = ({ field, value }: any) => {
    onFormItemChange({
      value: value.MediaFiles,
      field: 'MediaFiles',
      idx: '', //not used
    });
  };

  const tabItems = [
    {
      id: 1,
      title: 'vehicle Information',
      component: <VehicleBasicInfoComponent
        handleInnerFormChange={handleInnerFormChange}
        selectedVehicle={selectedVehicle}
        vehicleBodyTypes={vehicleBodyTypes}
        vehicleCategories={vehicleCategories}
        transporters={transporters}
        transportAgents={transportAgents}
      />,
      isVisible: true,
    },
    {
      id: 2,
      title: 'Media',
      component:
        <UploadMedia
          handleInnerFormChange={handleInnerMediaFormChange}
          mediaFilesList={selectedVehicle?.MediaMappings?.MediaFiles}
          ownerTypeId={1007}
          ownerId={parmas?.id}
          folderName={'VehicleRegistration'}
        />,
      isVisible: true,
    }
  ]

  return (
    <div className="flex flex-col items-center w-full px-5 overflow-auto h-auto pb-20">


      <TabContainer tabItems={tabItems} />


      <div className='flex w-full justify-end items-end h-20'>
        <button
          onClick={back}
          type='button'
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
        >
          Back
        </button>
        <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
          onClick={handleFormSubmit}

          type="submit"
        >
          Save
        </button>
      </div>
    </div>
  )
}
export default VehicleComponent;
